/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Catch_Boundary_DescriptionInputs */

const en_catch_boundary_description = /** @type {(inputs: Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We encountered an unexpected error. Please try again.`)
};

const es_catch_boundary_description = /** @type {(inputs: Catch_Boundary_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hemos encontrado un error inesperado. Intentalo de nuevo.`)
};

/**
* | output |
* | --- |
* | "We encountered an unexpected error. Please try again." |
*
* @param {Catch_Boundary_DescriptionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const catch_boundary_description = /** @type {((inputs?: Catch_Boundary_DescriptionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Catch_Boundary_DescriptionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_catch_boundary_description(inputs)
	return es_catch_boundary_description(inputs)
});